require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-online-banking-maintenance-live-alert-9-15-24.json") })
        }
      }, "path---articles-online-banking-maintenance-live-alert-9-15-24");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-online-banking-maintenance-live-alert-9-15-24!./.cache/json/articles-online-banking-maintenance-live-alert-9-15-24.json
// module id = 1719
// module chunks = 231608221292675